import React from 'react';
import { Card } from 'react-bootstrap';

import "../custom.css";

const Rule = () => {
  return (

    <Card>
        <Card.Body>
    <div >
      <p className='fss-2'>~* Rules & Regulation *~</p>
      <p className='padding'>1. Jobbing and Arbitrage is strickly prohibited in our platform </p>
      <p className='padding'>2. Cheating and Line and chakri trades are strickly prohibited in our platform.  </p>
      <p className='padding'>3. In trades if Same ip-address found in multiple accounts then trade will be not counted.</p>
      <p className='padding'>4. Dividend declaration or share spilt etc. On any share then position will be square off on day before closing rate.</p>   
      <p className='padding'>5. If found same trades in multiple accounts then trades will be not counted.</p>
      <p className='padding'>6. Incase above type of activity found in any account, trades will be deleted and informed to client/master/manager during the market.</p>
      <p className='padding'>7. Open position will be squar offf on buyer/seller quote. Not on bhavcopy or exchange settlement price.</p>
      <p className='padding'>8. Any trade found doubtful then it will deleted.</p>
      <p className='padding'>9. Locker / parking / standing trade system not allowed. So request you do trade regularly otherwise action will be taken.</p>
      <p className='padding'>Vertex Exch</p>


      <p className='fss-2 mt-3'>~* नियम और विनियम *~</p>
      <p className='padding'>1. हमारे प्लेटफॉर्म में जॉबिंग और आर्बिट्रेज सख्त वर्जित है</p>
      <p className='padding'>2. हमारे मंच में धोखाधड़ी और लाइन और चक्री व्यापार सख्त वर्जित हैं</p>
      <p className='padding'>3. अगर सेम आईपी ऐड्रेस से कई अकाउंट में ट्रेड मिल रहे हैं तो उसे डिलीट किए जाएंगे।</p>
      <p className='padding'>4. अगर किसी भी स्क्रिप्ट में डिविडेंड डिक्लेयर्ड होता है उस स्क्रिप्ट में जिसकी भी जो भी पोजीशन रहेगी वह गये दिन के क्लोजिंग रेट के हिसाब से क्लोज कर दी जाएगी।</p>
      <p className='padding'>5. अगर किसी मास्टर के या किसी क्लाइंट के कई अकाउंट में सेम पोजीशन या सेम ट्रेड्स मिलेंगे तो उसे भी रद्द किया जाएगा और डिलीट किया जाएगा।</p>
      <p className='padding'>6. किसी भी खाते में उपरोक्त प्रकार की गतिविधि पाए जाने पर, किसी भी समय के दौरान ट्रेड हटा दिया जाएगा और ग्राहक/मास्टर/प्रबंधक को सूचित किया जाएगा।</p>
      <p className='padding'>7. ट्रेडिंग समय एफएनओ 9:16 से 3.30 एमसीएक्स 9:01 से 23:30 सभी सीमा - स्टॉप लॉस - बाय स्टॉप - सेल स्टॉप कैंसिल 23:55</p>
      <p className='padding'>8. कोई भी डाउटफुल ट्रेड मिलने पर उसे डिलीट किया जाएगा।</p>
      <p className='padding'>9. जो भी स्क्रिप्ट बेन होगी उसे हटा दिया जाएगा।</p>
      <p className='padding'>10. लॉकर/पार्किंग/स्टैंडिंग सिस्टम की अनुमति नहीं है इसलिए नियमित रूप से व्यापार करें, अन्यथा कार्रवाई की जाएगी। </p>
      <p></p>
    </div>

    
    </Card.Body>
    </Card>
  );
};

export default Rule;